<template lang="pug">
.flex.py-1.px-2.rounded-b-lg.border.border-t-0.border-header-border.items-center(class="h-[1.68rem] bg-linear-to-b from-menu-bg-from to-menu-bg-from", @mouseover="handlePaused(true)", @mouseout="handlePaused")
  img(class="w-[1.12rem] h-[1.12rem]", :src="noticeIcon")
  .marquee-container.ms-2.flex-1.overflow-hidden(ref="containerRef")
    .marquee-content.w-fit.whitespace-nowrap(:class="{ 'is-paused': paused, 'animation-ready': isClient }", :style="animationStyle")
      .inline-block.me-6.text-primary-text.row.cursor-pointer(v-for="item of source", ref="contentRefs", class="text-[0.57143rem]", :key="item.id", @click="openAnnouncement(item)")
        .inline-block.max-w-64.align-middle.bg-affiliate-bar-chart-bar-light.rounded.truncate(class="py-[0.12rem] px-[0.32rem]") {{ item.title }}
        .marquee-text.inline-block.align-middle.ms-2.truncate {{ item.content }}
      template(v-for="i in repeat", :key="i")
        .inline-block.me-6.text-primary-text.cursor-pointer(v-for="item of source", class="text-[0.57143rem]", :key="`${item.id}-${i}`", @click="openAnnouncement(item)")
          .inline-block.max-w-64.align-middle.bg-affiliate-bar-chart-bar-light.rounded.truncate(class="py-[0.12rem] px-[0.32rem]") {{ item.title }}
          .marquee-text.inline-block.align-middle.ms-2.truncate {{ item.content }}
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch, nextTick } from 'vue'
import { useMainStore } from '@/stores/main'
import noticeIcon from 'assets/images/broadcast/notification_icon_notice_normal.png'

const SSR_DEFAULT_REPEAT = 3
const SSR_DEFAULT_DURATION = 20

const props = defineProps({
  source: {
    type: Array,
    default: () => [],
  },
})

const store = useMainStore()
const { announcementList } = useCommon()
const paused = ref(false)
const containerRef = ref(null)
const contentRefs = useTemplateRef('contentRefs')
const containerWidth = ref(0)
const contentWidth = ref(0)
const isClient = ref(false)

const dynamicDuration = computed(() => {
  if (!isClient.value) {
    return SSR_DEFAULT_DURATION
  }
  if (contentWidth.value > 0) {
    return (contentWidth.value * (repeat.value + 1)) / 100
  }
  return SSR_DEFAULT_DURATION
})

const repeat = computed(() => {
  if (!isClient.value) {
    return SSR_DEFAULT_REPEAT
  }
  if (containerWidth.value > 0 && contentWidth.value > 0) {
    return Math.ceil(containerWidth.value / contentWidth.value) * 2 - 1
  }
  return SSR_DEFAULT_REPEAT
})

const animationStyle = computed(() => {
  if (!isClient.value) {
    return {}
  }
  return { animationDuration: `${dynamicDuration.value}s` }
})

const announcements = computed(() => {
  return announcementList.value?.filter((item) => item.displayMode === 'ONLY_MARQUEE' || item.displayMode === 'BOTH') || []
})

const calculateDimensions = async () => {
  await nextTick()

  if (containerRef.value) {
    containerWidth.value = containerRef.value.offsetWidth
  }

  if (contentRefs.value) {
    let width = 0
    for (const item of contentRefs.value) {
      width += item.offsetWidth
    }
    contentWidth.value = width
  }
}

watch(
  () => props.source,
  () => {
    if (isClient.value) {
      calculateDimensions()
    }
  },
  { deep: true }
)

onMounted(() => {
  isClient.value = true
  calculateDimensions()
  window.addEventListener('resize', calculateDimensions)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', calculateDimensions)
})

const handlePaused = (toggle) => {
  paused.value = toggle === true
}

const openAnnouncement = (item) => {
  if (announcements.value && announcements.value.length > 0) {
    store.setSystemModalParams({ list: announcements.value, id: item.id, disableHourHide: true })
    store.setSystemModal('ModalAnnouncement')
  }
}
</script>

<style scoped>
.marquee-content {
  animation: none;
}

.marquee-content.animation-ready {
  animation: marquee linear infinite;
}

.marquee-content .marquee-text * {
  display: inline !important;
}

.marquee-content.is-paused {
  animation-play-state: paused;
}

@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-50%);
  }
}
</style>
